export default __webpack_public_path__ + "static/i_3-b08e66a3c2dbe856eec13e626de46086.png";